import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IVenueDetailsResponse, updateVenueDetails } from 'src/api/updateVenueDetails';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { IFormValues } from 'src/components/VenueDetailsEditModal/types';

export const useUpdateVenueDetails = (onMutationSuccess: () => void) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    ({ id, body }: { id: string; body: IFormValues }) =>
      updateVenueDetails(id, {
        name: body.name,
        is_trial: body.isTrial,
      }),
    {
      onSuccess: async (data: IVenueDetailsResponse) => {
        await queryClient.invalidateQueries({ queryKey: ['venue', data.venue_id] });
        showSnackbar({
          status: SnackbarStatus.SUCCESS,
          message: `You have successfully updated ${data.name} venue.`,
        });
        onMutationSuccess();
      },
      onError: () => {
        showSnackbar({
          status: SnackbarStatus.ERROR,
          message: 'Something went wrong whilst updating a venue.',
        });
      },
    },
  );
};
